export default __webpack_public_path__ + "static/media/133_cyclopee_kawai0001.27305041.png";